import { PopUpManagerSlice } from "./types";

export const initialState: PopUpManagerSlice = {
	variant: undefined
};
